import type { ReactNode } from "react";
import Card from "../basic/Card";
import { vstack } from "../../../../styled-system/patterns";
import { Flex, VStack } from "../../../../styled-system/jsx";

interface Props {
  title?: ReactNode;
  byline?: ReactNode;
  status?: ReactNode;

  children?: ReactNode;
}

const SummaryCard = ({ title, byline, status, children }: Props) => {
  const titleIsText = typeof title === "string";
  return (
    <Card
      className={vstack({
        alignItems: "stretch",
      })}
      padding="large"
    >
      <Flex justifyContent={"space-between"} alignItems={"start"} width={"100%"}>
        <VStack gap="xsmall" alignItems={"start"} flex={1} minWidth={0}>
          {titleIsText ?
            <h3
              style={{
                margin: 0,
                lineHeight: "1",
              }}
            >
              {title}
            </h3>
          : title}
          {byline && <small>{byline}</small>}
        </VStack>
        {status && <div style={{ marginLeft: "auto" }}>{status}</div>}
      </Flex>

      {children}
    </Card>
  );
};

export default SummaryCard;
